import React from "react";

const VisitorParamsContext = React.createContext();
export const VisitorParamsProvider = VisitorParamsContext.Provider;
export const VisitorParamsConsumer = VisitorParamsContext.Consumer;

export default VisitorParamsContext;
